import {Router} from "@/rawdogjs/src/router";
import {ApiClientBase} from "./WebApiClientBase";
import {ParcelWebHttpClient} from "./ParcelWebHttpClient";
import {AuthenticationManager} from "./AuthenticationManager";

export class TenantApi extends ApiClientBase {


    constructor(
        router: Router,
        httpClient: ParcelWebHttpClient,
        authenticationManager: AuthenticationManager,
        url: string
    ) {
        super(
            '/api/tenants',
            router,
            httpClient,
            authenticationManager,
            url
        );
    }

}